/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_Google_DescInputs */

const en_privacy_section_5_google_desc = /** @type {(inputs: Privacy_Section_5_Google_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`website analytics and tag management.`)
};

const lv_privacy_section_5_google_desc = /** @type {(inputs: Privacy_Section_5_Google_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mājaslapas analītika un tagu pārvaldība.`)
};

/**
* | output |
* | --- |
* | "website analytics and tag management." |
*
* @param {Privacy_Section_5_Google_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_google_desc = /** @type {((inputs?: Privacy_Section_5_Google_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_Google_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_google_desc(inputs)
	return en_privacy_section_5_google_desc(inputs)
});